import { useEffect, useMemo } from 'react'

import { useFundingNav } from '@hooks/useFundingNav'

import { DepositTarget } from './types'

const isDepositTarget = (v: unknown): v is DepositTarget =>
  v === 'wallet' || v === 'trading-account'

export const useDepositTarget = (params: {
  isCFD: boolean
  targetParam?: string
  dashboardContext?: 'traders-room' | 'payment-agent'
}): DepositTarget => {
  const { isCFD, targetParam, dashboardContext = 'traders-room' } = params
  const { go } = useFundingNav()

  const target = useMemo<DepositTarget>(() => {
    if (!isCFD) return 'wallet'
    return isDepositTarget(targetParam) ? targetParam : 'trading-account'
  }, [isCFD, targetParam])

  useEffect(() => {
    if (!isCFD) {
      if (targetParam !== 'wallet') {
        go(`/dashboard/${dashboardContext}/deposit/wallet`, { replace: true })
      }
      return
    }
    if (!isDepositTarget(targetParam)) {
      go(`/dashboard/${dashboardContext}/deposit/trading-account`, { replace: true })
    }
  }, [isCFD, go, targetParam, dashboardContext])

  return target
}
